import { renderTemplateVariables } from '../../../common/templateVariables';

const stringMixin = {
    methods: {
        /**
         * Fills every [variable] in text — the logic lives in common/templateVariables.js
         * (same function as the customer site); this only maps the CRM options.
         *
         * @param text
         * @param trip     parsed Nezasa itinerary
         * @param options  { lang_code, general, globalinfo: { signature, salutation }, reisedesigner, tripUrl, loginCode }
         * @returns {*}
         */
        replaceTemplatePlaceholders(text, trip, options) {
            const lang_full_name = options?.general?.Englisch?.lang_code?.[options?.lang_code];
            const langFile = options?.general?.[lang_full_name] || options?.general?.Englisch;
            return renderTemplateVariables(text, {
                trip,
                salutations: langFile?.salutations,
                salutationConfig: options?.globalinfo?.salutation,
                signature: options?.globalinfo?.signature,
                reisedesigner: options?.reisedesigner,
                tripUrl: options?.tripUrl,
                loginCode: options?.loginCode,
            });
        }
    }
};

export default stringMixin
